import isServer from './isServerForSSR';

export default isServer ? (global as any) : (window as any);
